import normalVertex from  './shader/v/normal.vert';
import screenFragment from './shader/f/screen.frag';

//
window.WEBGL = {

	res   : RES,
	fov   : 15,
	ready : false,

	once(){

		//
		this.width  = WW;
		this.height = WH;
		this.aspect = this.width / this.height;

		//
		this.renderer = new OGL.Renderer({
			width     : this.width,
			height    : this.height,
			alpha     : true,
			antialias : false,
			dpr       : this.res
		});
		this.gl = this.renderer.gl;
		document.body.appendChild(this.gl.canvas);
		this.gl.canvas.setAttribute('id','js-webgl');

		//
		this.far = ( this.height / 2) / Math.tan(( this.fov * Math.PI / 180) / 2);
		this.camera = new OGL.Camera( this.gl, {
			near   : 0.1,
			far    : this.far + this.width,
			aspect : this.aspect,
			fov    : this.fov
		});
		this.camera.position.z = this.far;
		this.camera.lookAt([0, 0, 0]);

		//
		this.world = new OGL.Transform();

		//
		this.scene = new OGL.Transform();
		this.sceneTarget = new OGL.RenderTarget( this.gl, {
			width  : this.width  * this.res,
			height : this.height * this.res,
		});

		//
		this.map = new OGL.Transform();
		this.mapTarget = new OGL.RenderTarget( this.gl, {
			width  : this.width  * this.res,
			height : this.height * this.res,
		});

		//
		this.logo.once();

		//
		this.onInitTrailScreen();

		//
		this.onResize();
		this.ready = true;

	},

	//
	trail : {
		screen : null,
		flowmap : null,
		geometry : null,
		program : null,
		lastTime : null,
		last : new OGL.Vec2(),
		mouse : new OGL.Vec2(-1),
		velocity : new OGL.Vec2(),
		prop : {
			size        : getParam('size') ? Number(getParam('size')) : 128,
			falloff     : getParam('falloff') ? Number(getParam('falloff')) : 0.4,
			alpha       : getParam('alpha') ? Number(getParam('alpha')) : 1,
			dissipation : getParam('dissipation') ? Number(getParam('dissipation')) : 0.98,
			// size        : 128,
			// falloff     : 0.4,
			// alpha       : 1,
			// dissipation : 0.98,
		}
	},
	onInitTrailScreen(){

		//
		this.trail.geometry = new OGL.Plane( this.gl,{
			width  : 1,
			height : 1
		});

		//
		this.trail.flowmap = new OGL.Flowmap( this.gl, {
			// size : 128,
			// falloff : 0.3,
			// alpha : 1,
			// dissipation : 0.98,
			size        : this.trail.prop.size,
			falloff     : this.trail.prop.falloff,
			alpha       : this.trail.prop.alpha,
			dissipation : this.trail.prop.dissipation,
		});

		//
		const u_noise_power = getParam('u_noise_power') ? Number(getParam('u_noise_power')) : 4;
		const u_noise_disp  = getParam('u_noise_disp') ? Number(getParam('u_noise_disp')) : 2;
		this.trail.program = new OGL.Program(this.gl, {
			vertex: normalVertex,
			fragment: screenFragment,
			cullFace : null,
			transparent : true,
			depthTest : false,
			depthWrite : false,
			uniforms: {
				tLogo : { value : this.logo.target.texture },
				tMap : { value : this.mapTarget.texture },
				tDiffuse : { value : this.sceneTarget.texture },
				tFlow : this.trail.flowmap.uniform,
				u_noise_power : { value : u_noise_power }, // 4
				u_noise_disp : { value : u_noise_disp }, // 2
				u_mouse : { value : 0 },
				uv_resolution  : { value : new OGL.Vec2( 0.0, 0.0 ) },
				uv_resolution  : { value : new OGL.Vec2( 0.0, 0.0 ) },
			}
		});

		this.trail.screen = new OGL.Mesh( this.gl, { geometry : this.trail.geometry, program : this.trail.program });
		this.trail.screen.setParent( this.world );

	},

	onUpdateEffect(){

		//
		const m = styleMouse.body.array[0];
		const e = m.delta;

		//
		this.trail.mouse.set( m.shader.x, 1 - m.shader.y );

		//
		if( pageTransition.current.name === '404' ){
			this.trail.program.uniforms.u_mouse.value = 0.1;
		} else if( this.trail.program.uniforms.u_mouse.value != 0 ){
			this.trail.program.uniforms.u_mouse.value = 0;
		}


		//
		if (!this.trail.lastTime) {
			this.trail.lastTime = performance.now();
			this.trail.last.set( e.x, e.y );
		}

		//
        const deltaX = e.x - this.trail.last.x;
        const deltaY = e.y - this.trail.last.y;
        this.trail.last.set( e.x, e.y );

        //
        let time = performance.now();
		let delta = Math.max( 1, time - this.trail.lastTime );
		this.trail.lastTime = time;
		this.trail.velocity.x = deltaX / delta;
		this.trail.velocity.y = deltaY / delta;
		this.trail.velocity.needsUpdate = true;

		//
		if (!this.trail.velocity.needsUpdate) {
			this.trail.mouse.set(-1);
			this.trail.velocity.set(0);
		}
		this.trail.velocity.needsUpdate = false;
		this.trail.flowmap.aspect = this.aspect;
		this.trail.flowmap.mouse.copy(this.trail.mouse);
		this.trail.flowmap.velocity.lerp( this.trail.velocity, this.trail.velocity.len() ? 0.1 : 0.05 );
		this.trail.flowmap.update();

	},


	onResize(){

		//===
		this.width  = WW;
		this.height = WH;
		this.aspect = this.width / this.height;

		//===
		this.renderer.setSize( this.width, this.height );

		//===
		this.far = ( this.height / 2) / Math.tan(( this.fov * Math.PI / 180) / 2);
		this.camera.perspective({
			far    : this.far + this.width,
			aspect : this.aspect,
		});
		// this.camera.position.z = this.far;
		this.camera.position.z = this.far;

		//===
		if( this.trail.screen ){
			this.trail.screen.scale.x = this.width;
			this.trail.screen.scale.y = this.height;
			this.trail.screen.scale.z = 1;
			this.trail.screen.program.uniforms.uv_resolution.value[0] = this.trail.screen.scale.x;
			this.trail.screen.program.uniforms.uv_resolution.value[1] = this.trail.screen.scale.y;
		}

		//===
		if( this.logo.ready ){
			this.logo.onResize();
		}

	},

	onRender(){

		//
		if( !DETECT.reduced && IS_SPLASHED ) this.onUpdateEffect();

		//
		// if( pageTransition.anim.leave.ing ) return false;

		//
		if( this.logo.ready ){
			this.renderer.render({
				target : this.logo.target,
				scene  : this.logo.scene,
				camera : this.camera
			});
			this.logo.onRender();
		}

		//
		this.renderer.render({
			target : this.mapTarget,
			scene  : this.map,
			camera : this.camera
		});

		//
		this.renderer.render({
			target : this.sceneTarget,
			scene  : this.scene,
			camera : this.camera
		});

		//
		this.renderer.render({
			target : null,
			scene  : this.world,
			camera : this.camera
		});

		//
		if( PRE_RENDER_WEBGL ){

			this.dom.onPreRender();

		} else {

			// if( GLOBAL_TIME % 24 === 0 && !pageTransition.anim.leave.ing ) this.dom.onUpdate();
			this.dom.onUpdate();
			this.dom.onRender();

		}

	}

}






















































































































































































































